module.exports = __webpack_public_path__ + "static/trade-2-bd5d43014f2b5088780b1a1371da8b9d.jpg";